import { Programme } from "../services/Api/swagger";

export const isProgrammesServiceFidelisation = (programmes) => {
  const programmeFid =
    programmes.filter(
      (programme) =>
        programme.listeServices &&
        programme.listeServices.find(
          (element) => element.type === "FIDELISATION"
        )
    ) || false;
  return programmeFid.length > 0 ? true : false;
};

export const isProgrammeServiceFidelisation = (programme) => {
  const programmeFid =
    (programme.listeServices &&
      programme.listeServices.find(
        (element) => element.type === "FIDELISATION"
      )) ||
    false;
  return programmeFid ? true : false;
};

export const isProgrammesHasListeProduit = (programmes) => {
  const listeProduitsExist =
    programmes.filter(
      (programme) =>
        programme.listeProduits && programme.listeProduits.length > 0
    ) || false;
  return listeProduitsExist.length > 0 ? true : false;
};

export const isProgrammeHasListeProduit = (programme) => {
  const listeProduitsExist =
    programme.listeProduits && programme.listeProduits.length > 0;
  return listeProduitsExist ? true : false;
};

export const isProgrammesHasRemboursement = (programmes) => {
  const hasRemboursement = programmes.filter((pgm) =>
    pgm.listeProduits.find((produit) =>
      produit.listeGaranties.find(
        (garantie) => garantie.type === "Remboursement"
      )
    )
  );
  return hasRemboursement.length > 0 ? true : false;
};

export const isProgrammesFidSeuleSansVehicule = (
  programmes: Programme[] | undefined
): any => {
  const programmeFidAvecVehicule =
    (programmes &&
      programmes.filter(
        (programme) =>
          (programme.listeServices &&
            programme.listeServices.find(
              (element) =>
                element.objetRisque.toLowerCase() === "moyentransport"
            )) ||
          (programme.listeProduits &&
            programme.listeProduits.find(
              (element) =>
                element.objetRisque.toLowerCase() === "moyentransport"
            ))
      )) ||
    false;
  return programmeFidAvecVehicule && programmeFidAvecVehicule.length > 0
    ? false
    : true;
};

export const isProgrammesHasRenouvellement = (programmes: Programme[]) => {
  const hasRemboursement = programmes.filter(
    (pgm) => pgm.renouvellement === "O"
  );
  return hasRemboursement.length > 0 ? true : false;
};

export const isProgrammeHasRenouvellement = (programme: Programme) => {
  const hasRenouvellement = programme.renouvellement === "O";
  return hasRenouvellement ? true : false;
};
